<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      padding: 10px;
    "
  >
    <div
      style="flex: 3; overflow: hidden; display: flex; flex-direction: column"
    >
      <ul
        style="
          width: 100%;
          border: 1px solid #e2e2e2;
          border-bottom: 0;
          padding: 10px;
          display: flex;
          flex-wrap: wrap;
        "
      >
        <el-space wrap>
          <el-select
            v-model="state.params.Params.GysId"
            placeholder="--请选择供应商--"
            value-key="Mc"
            :disabled="!Array.isArray(state.gysData)"
            @change="
              delete state.model.GysZh;
              onLoadGysZh();
            "
          >
            <el-option
              v-for="item in state.gysData"
              :key="item.Id"
              :label="item.Mc"
              :value="item.Id"
            />
          </el-select>
          <el-input
            v-model="state.params.Params.Key"
            placeholder="关键字"
            clearable
            @clear="
              delete state.params.Params.Key;
              onLoad();
            "
          ></el-input>
          <el-dropdown split-button @click="onLoad" type="primary">
            查询
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                  重置
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>
      </ul>
      <ul style="overflow: hidden; display: flex; flex-direction: column">
        <el-table
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.Order,
            order: state.params.Asc == false ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
        >
          <el-table-column width="60" align="center" fixed="left">
            <template #header>选择</template>
            <template #default="{ row }">
              <el-checkbox
                :checked="row.IsXz"
                :disabled="row.IsDz && row.Jszj <= row.Yfje"
                @change="onSelect(row, $event)"
              />
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="#"
            width="50"
            type="index"
            :index="
              (index) =>
                (state.params.PageIndex - 1) * state.params.PageSize + index + 1
            "
            align="center"
          />
          <el-table-column label="商品信息" min-width="200">
            <template #default="{ row }">
              <div>
                <ul>
                  <text style="color: #000">{{ row.SpMc }}</text>
                  <text style="color: #a2a2a2">[{{ row.GysMc }}]</text>
                  <el-tag v-if="row.IsDz" type="info" size="small" style="margin-left: 5px">已申请对账单{{ row.Yfje > 0 ? $priceFormat(row.Yfje) + '元' : '' }}</el-tag>
                </ul>
                <ul style="font-size: 12px; line-height: 12px; color: #a2a2a2">
                  {{
                    row.SpPlMc +
                    "  " +
                    row.Syrq +
                    "  " +
                    row.SpTcMc +
                    "  " +
                    $priceFormat(row.Jsdj) +
                    "/" +
                    row.SpTcDw +
                    " x " +
                    row.Sl
                  }}
                </ul>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="订单信息" min-width="200">
            <template #default="{ row }">
              <div>
                <ul>
                  <text style="color: #000">{{ row.Dh }}</text>
                  <text style="color: #a2a2a2">[{{ row.KhMc }}]</text>
                </ul>
                <ul style="font-size: 12px; line-height: 12px; color: #a2a2a2">
                  {{
                    row.KhLxr + "  " + row.KhSjhm + "  " + row.Xdsj
                  }}
                </ul>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Jszj" label="结算金额(元)" width="120">
            <template #default="{ row }">
              <c_money :value="row.Jszj"></c_money>
            </template>
          </el-table-column>
          <el-table-column prop="Fkje" label="此次申请金额(元)" width="130">
            <template #default="{ row }">
              <c_money :value="row.Fkje"></c_money>
            </template>
          </el-table-column>
          <el-table-column prop="Yfje" label="已付金额(元)" width="120">
            <template #default="{ row }">
              <c_money :value="row.Yfje"></c_money>
            </template>
          </el-table-column>
          <el-table-column
            label="本次付款"
            align="center"
            width="130"
            :formatter="$tab_MoneyFormat"
            fixed="right"
          >
            <template #default="{ row }">
              <el-input-number
                v-model="row.Fkje"
                v-if="state.selectArr.some((w) => w.Id == row.Id)"
                :min="0"
                :max="row.Jsqk"
                :precision="2"
                :controls="false"
                @change="onBuildModel"
                style="width: 100%"
              />
              <text v-else>{{ $priceFormat(row.Fkje) }}</text>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="Fl"
            label="返利"
            width="100"
            :formatter="$tab_MoneyFormat"
          >
            <template #default="{ row }">
              <el-input
                v-if="row.IsXz"
                v-model="row.Fl"
                type="number"
              ></el-input>
              <c_money v-else :value="row.Fl"></c_money>
            </template>
          </el-table-column> -->
        </el-table>
      </ul>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.PageIndex"
        @onLoad="
          (pageIndex) => {
            state.params.PageIndex = pageIndex;
            onLoad();
          }
        "
      >
      </c_page>
    </div>
    <div
      style="
        flex: 1;
        margin-left: 10px;
        box-shadow: 0 0 10px 1px #e2e2e2;
        border-radius: 7px;
      "
    >
      <div style="padding: 30px 20px">
        <ul style="display: flex; border-bottom: 1px solid #e2e2e2">
          <li
            style="
              flex: 1;
              padding: 20px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            "
          >
            <text style="color: #080">{{ state.selectArr?.length }}笔</text>
            <text style="color: #a2a2a2; font-size: 12px">已勾选</text>
          </li>
          <li
            style="
              flex: 1;
              padding: 20px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              border-left: 1px solid #e2e2e2;
            "
          >
            <c_money :value="state.model.Zje"></c_money>
            <text style="color: #a2a2a2; font-size: 12px">合计付款金额</text>
          </li>
        </ul>
        <ul
          style="
            display: flex;
            flex-direction: column;
            overflow: hidden;
            margin-top: 10px;
          "
        >
          <el-form
            label-position="top"
            label-width="auto"
            :model="state.model"
            style="flex: 1; overflow-y: auto; padding: 0 10px"
            ref="formDom"
          >
            <el-form-item
              label="付款方式"
              prop="Fkfs"
              :rules="[
                { required: true, message: '请选择付款方式', trigger: 'blur' },
              ]"
            >
              <el-radio-group v-model="state.model.Fkfs">
                <el-radio :label="1">转账</el-radio>
                <el-radio :label="2">现金</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="到账银行"
              prop="GysZh"
              :rules="[
                { required: true, message: '请选择到账银行', trigger: 'blur' },
              ]"
              v-if="state.model.Fkfs == 1"
            >
              <el-select
                v-model="state.model.GysZh"
                placeholder="--请选择到账银行：--"
                value-key="Id"
                @change="onGyszhChange"
              >
                <el-option
                  v-for="item in state.zhData || []"
                  :key="item"
                  :label="
                    '卡号：' +
                    item.Kh +
                    '，收款人：' +
                    item.Skr +
                    '，开户行：' +
                    item.Khyh
                  "
                  :value="item"
                />
                <template #footer>
                  <el-button size="small" @click="onLoadGysZh()">
                    刷新
                  </el-button>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item
              label="业务主管审批"
              prop="YwzgId"
              :rules="[
                {
                  required: true,
                  message: '请选择业务主管',
                  trigger: 'blur',
                },
              ]"
            >
              <div style="display: flex; width: 100%">
                <el-input
                  v-model="state.model.YwzgXm"
                  style="flex: 1; margin-right: 10px"
                /><el-button type="warning" @click="onSelectYongHu(3)"
                  >选择</el-button
                >
              </div>
            </el-form-item>
            <el-form-item
              label="业务负责人审批"
              prop="YwrId"
              :rules="[
                {
                  required: true,
                  message: '请选择业务负责人',
                  trigger: 'blur',
                },
              ]"
            >
              <div style="display: flex; width: 100%">
                <el-input
                  v-model="state.model.YwrXm"
                  style="flex: 1; margin-right: 10px"
                /><el-button type="warning" @click="onSelectYongHu(1)"
                  >选择</el-button
                >
              </div>
            </el-form-item>
            <el-form-item
              label="财务负责人审批"
              prop="CwrId"
              :rules="[
                {
                  required: true,
                  message: '请选择财务负责人',
                  trigger: 'blur',
                },
              ]"
            >
              <div style="display: flex; width: 100%">
                <el-input
                  v-model="state.model.CwrXm"
                  style="flex: 1; margin-right: 10px"
                /><el-button type="warning" @click="onSelectYongHu(2)"
                  >选择</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label="付款备注">
              <el-input
                type="textarea"
                v-model="state.model.Bz"
                :autosize="{ minRows: 4 }"
                placeholder="备注"
              />
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="onSubmit()">申请付款</el-button>
        </ul>
      </div>
    </div>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showYongHu"
        :title="state.title"
        @close="state.showYongHu = false"
      >
        <c_LvYouDingDanSelectUser
          @close="onCloseYongHu"
          :id="state.selectId"
        ></c_LvYouDingDanSelectUser>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  shangpindingdanmingxi_dz_list,
  gongyingshang_select,
  gongyingshangzhanghu_selectbygysid,
  duizhangdan_add,
} from "@/http/api";
import { ElMessage } from "element-plus";

export default {
  components: {},
  setup() {
    const state = reactive({
      tableData: [],
      params: {
        PageSize: 20,
        PageIndex: 1,
        Params: { TableName: "DuiZhangDan_List" },
      },
      model: { Lx: 1 },
      selectArr: [],
    });
    const formDom = ref();
    onMounted(() => {
      loadGys();
    });

    const onLoad = () => {
      delete state.tableData;
      shangpindingdanmingxi_dz_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });

      onLoadGysZh();
    };

    //加载供应商下拉数据
    const loadGys = () => {
      gongyingshang_select().then((res) => {
        if (res.status == 200) state.gysData = res.data;
      });
    };

    const onLoadGysZh = () => {
      if (!state.params.Params.GysId) {
        ElMessage({
          type: "warning",
          message: "请选择供应商",
          grouping: true,
        });
        return false;
      }
      gongyingshangzhanghu_selectbygysid(state.params.Params.GysId).then(
        (res) => {
          if (res.status == 200) state.zhData = res.data;
        }
      );
    };

    const onSelect = (row, checked) => {
      if (row.IsDz && row.Jszj <= row.Yfje) {
        ElMessage.warning("该商品已申请对账单且已付清，不能重复申请!");
        return;
      }
      row.IsXz = true;
      if (checked) {
        state.selectArr.push(row);
      } else {
        row.Fkje = 0;
        const index = state.selectArr.findIndex((w) => w.Id == row.Id);
        state.selectArr.splice(index, 1);
        onBuildModel();
      }
    };

    const onFkjeChange = (row) => {
      let item = state.selectArr.find((w) => w.Id == row.Id);
      item.Fkje = row.Fkje;
      onBuildModel();
    };

    const onBuildModel = () => {
      state.model.Zje = 0;

      state.selectArr.forEach((e) => {
        state.model.Zje += e.Fkje;
      });
    };

    const onGyszhChange = (zh) => {
      state.model.Dzyh = zh.Khyh;
      state.model.Dzkh = zh.Kh;
      state.model.Skr = zh.Skr;
    };

    const onSelectYongHu = (type) => {
      if (type == 1) {
        state.title = "选择业务负责人";
        state.selectId = state.model.YwrId;
      } else if (type == 2) {
        state.title = "选择财务负责人";
        state.selectId = state.model.CwrId;
      } else if (type == 3) {
        state.title = "选择业务主管";
        state.selectId = state.model.YwzgId;
      }
      state.showYongHu = true;
    };

    const onCloseYongHu = (item) => {
      if (state.title == "选择业务负责人") {
        state.model.YwrId = item.Id;
        state.model.YwrXm = item.Xm;
      } else if (state.title == "选择财务负责人") {
        state.model.CwrId = item.Id;
        state.model.CwrXm = item.Xm;
      } else if (state.title == "选择业务主管") {
        state.model.YwzgId = item.Id;
        state.model.YwzgXm = item.Xm;
      }
      state.showYongHu = false;
    };

    const onSubmit = async () => {
      // 校验供应商
      if (!state.params.Params.GysId) {
        ElMessage.warning("请选择供应商!");
        return false;
      }

      // 表单校验(付款方式、审批人等)
      try {
        await formDom.value?.validate();
      } catch {
        return false;
      }

      const mxs = state.selectArr.map((m) => {
        return { Id: m.Id, Yfje: m.Qk, Je: m.Fkje };
      });
      if (mxs.length <= 0) {
        ElMessage.warning("请选择订单!");
        return false;
      }

      if (mxs.some((s) => !s.Je || s.Je <= 0)) {
        ElMessage.warning("请输入付款金额!");
        return false;
      }

      if (mxs.some((s) => {
        const row = state.selectArr.find((w) => w.Id == s.Id);
        return row && row.IsDz && row.Jszj <= row.Yfje;
      })) {
        ElMessage.warning("存在已申请对账单且已付清的商品，请移除后重试!");
        return false;
      }

      state.model.Lx = 1;
      state.model.GysId = state.params.Params.GysId;
      state.model.DdMxs = mxs;

      duizhangdan_add(state.model).then((res) => {
        if (res.status == 200) {
          ElMessage.success(res.data);
          state.selectArr = [];
          state.model = { Lx: 1, Zje: 0 };
          onLoad();
        }
      });
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, {
        params: {
          PageSize: 20,
          PageIndex: 1,
          Params: {},
          Order: "Cjsj",
          Asc: false,
        },
      });
      onLoad();
    };

    const onBuildTotal = () => {
      let totalCount = 0,
        totalJszj = 0,
        totalFlje = 0,
        totalYfje = 0;
      state.tableData?.forEach((e, index) => {
        if (e.IsXz) {
          totalCount += index;
          totalJszj += e.Jszj;
          totalFlje += e.Fl;
          totalYfje += e.Yfje;
        }
      });

      return {
        totalCount,
        totalJszj,
        totalFlje,
        totalYfje,
      };
    };

    return {
      state,
      formDom,
      onLoad,
      onReset,
      onBuildTotal,
      onSubmit,
      onLoadGysZh,
      onSelect,
      onBuildModel,
      onFkjeChange,
      onGyszhChange,
      onSelectYongHu,
      onCloseYongHu,
    };
  },
};
</script>
<style>
.drawerCss {
  width: 40vw !important;
}

.drawerCss > div {
  overflow: hidden;
  padding: 0 !important;
}
</style>
